// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__Yk9Pu","table__product-name-link":"table_table__product-name-link__210Ji","table__product-info":"table_table__product-info__2eizv"};